import { render, staticRenderFns } from "./TotalRevenueCard.vue?vue&type=template&id=507e5758&lang=html&"
import script from "./TotalRevenueCard.vue?vue&type=script&lang=js&"
export * from "./TotalRevenueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports